import React from 'react';
import SidebarNoData from 'components/ScheduleSidebar/SidebarNoData.js';
import SidebarShiftDetails from 'components/ScheduleSidebar/SidebarShiftDetails.js';
import SidebarTimeOff from 'components/ScheduleSidebar/SidebarTimeOff.js';
import SidebarExchangeOffer from 'components/ScheduleSidebar/SidebarExchangeOffer.js';
import SidebarDropOffer from 'components/ScheduleSidebar/SidebarDropOffer.js';
import SidebarExchangeBids from 'components/ScheduleSidebar/SidebarExchangeBids.js';
import SidebarAvailableShifts from 'components/ScheduleSidebar/SidebarAvailableShifts';
import SidebarExchangesAndDrops from 'components/ScheduleSidebar/SidebarExchangesAndDrops';
import SidebarSetAvailability from 'components/ScheduleSidebar/SidebarSetAvailability';
import SidebarCoworkers from './ScheduleSidebar/SidebarCoworkers';

export default class ScheduleSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.setDefaultActiveStates();
    this.previousHeight = 0;
  }

  componentWillMount() {
    this.setDefaultActiveStates();

    UserStore.on(
      'user:location:load:success',
      function (data) {
        this.resizeSidebar();
      },
      this,
    );
  }

  setDefaultActiveStates() {
    this.state = {
      defaultActive: true,
      setShiftDetailsActive: false,
      setAvailableShiftsActive: false,
      setExchangeAndDropsActive: false,
      setExchangeOfferActive: false,
      setShiftExchangeBids: false,
      setDropOfferActive: false,
    };
  }

  isEmptyDay(day) {
    let bool = false;
    if (
      Utils.isNotDefined(day.availableExchanges)
      && Utils.isNotDefined(day.availableShifts)
      && Utils.isNotDefined(day.offeredShifts)
      && Utils.isNotDefined(day.scheduledShifts)
      && Utils.isNotDefined(day.unavailableRequests)
      && Utils.isNotDefined(day.unavailableShifts)
    ) {
      bool = true;
    }

    return bool;
  }

  resizeSidebar() {
    setTimeout(function () {
      const panels = document.querySelectorAll('aside .sidebarContainer > div');
      let totalHeight = 60;
      [].forEach.call(panels, (el) => {
        totalHeight += parseInt(el.offsetHeight);
      });
      if (this.previousHeight != totalHeight) {
        this.previousHeight = totalHeight;
        Utils.resizeContainer(totalHeight);
      }
    }, 800);
  }

  componentWillReceiveProps() {
    this.resizeSidebar();
  }

  dayOutsideCurrentMonth(data) {
    return _.isEmpty(data);
  }

  render() {
    let { selectedDate } = this.props;
    
    const that = this;

    this.setDefaultActiveStates();

    const today = new Date();

    today.setHours(0, 0, 0, 0);

    let hasFullDayUnavailables = false;
    let hasPartialUnavailables = false;

    if (this.props.selectedDayData != null) {
      if (this.isEmptyDay(this.props.selectedDayData)) {
        if (this.dayOutsideCurrentMonth(this.props.selectedDayData)) {
          // If the day is empty and not within the current month
          // that's being viewed (greyed out on the calendar),
          // then hide sidebar contents by setting selectedDate
          // to null.
          selectedDate = null;
          this.state.defaultActive = true;
        } else {
          this.state.defaultActive = false;
          this.state.setDropOfferActive = false;
        }
      } else {
        this.state.defaultActive = false;

        if (_.isEmpty(this.props.selectedDayData) && moment(selectedDate).isBefore(today)) {
          this.state.defaultActive = true;
        }

        if (
          !Utils.isNotDefined(this.props.selectedDayData.scheduledShifts)
          && this.props.selectedDayData.scheduledShifts.length > 0
        ) {
          this.state.setShiftDetailsActive = true;
        }

        // For Availablilities
        if (
          !Utils.isNotDefined(this.props.selectedDayData.unavailableShifts)
          && this.props.selectedDayData.unavailableShifts.length > 0
        ) {
          const unavailables = this.props.selectedDayData.unavailableShifts;

          // It's not possible to have both partial and full day unavails,
          // so we only need to check the first one.
          if (unavailables[0].partial) {
            hasPartialUnavailables = true;
          } else {
            hasFullDayUnavailables = true;
          }
        }

        if (!Utils.isNotDefined(this.props.selectedDayData.offeredShifts)) {
          this.state.setAvailableShiftsActive = true;
        }

        const { availableExchanges } = this.props.selectedDayData;
        if (
          (!Utils.isNotDefined(this.props.selectedDayData.availableExchanges)
            && this.props.selectedDayData.availableExchanges.length > 0)
          || !Utils.isNotDefined(this.props.selectedExchangeShift)
        ) {
          this.state.setExchangeAndDropsActive = true;

          if (this.props.exchangeType == 'exchange') {
            this.state.setExchangeOfferActive = true;
          } else if (this.props.exchangeType == 'my exchange') {
            this.state.setShiftExchangeBids = true;
          } else if (this.props.exchangeType == 'drop') {
            this.state.setDropOfferActive = true;
          }
        }
      }
    }

    const containerClasses = (this.props.openSidebar || (!this.props.openSidebar && this.props.openCoworkerSidebar)) 
      ? 'sidebarContainer open' 
      : 'sidebarContainer';
    const secondaryClasses = (this.props.openSidebar || (!this.props.openSidebar && this.props.openCoworkerSidebar)) 
      ? 'secondarySidebar open' 
      : 'secondarySidebar';

    let scheduledShifts = [];
    if (this.props.selectedDayData) {
      scheduledShifts = _.sortBy(
        this.props.selectedDayData.scheduledShifts,
        shift => shift.start_time,
      );
    }
    this.resizeSidebar();

    // Don't show Availability pickers when there is a
    // scheduled full-day time off and is not before today
    let sidebarSetAvailability = '';
    if (!hasFullDayUnavailables && !moment(selectedDate).isBefore(today)) {
      sidebarSetAvailability = (
        <SidebarSetAvailability
          selectedDate={selectedDate}
          availableShifts={
            this.props.selectedDayData ? this.props.selectedDayData.availableShifts : null
          }
          showAllDay={!(hasFullDayUnavailables || hasPartialUnavailables)}
        />
      );
    }

    // Hiding the Create Request button:
    // 1. If the brand is adp OR
    // 2. If there is at least 1 shift
    // 3. And if the user's time off setting is "full day"
    const hideCreateRequestButton = window.EmployeeWeb.ENVConfig.brand === 'adp' 
    || (scheduledShifts.length > 0 && Utils.getCoreUser().company.time_off_mode == 'full_day')
    && (scheduledShifts.length > 0 && !Utils.getCoreUser().company.allow_time_off_request_with_conflict);

    // If no selected date, don't show anything in the sidebar
    if (!selectedDate) {
      return (
        <aside>
          <div>
            <div className={containerClasses}>
              <SidebarNoData 
                selectedDate={selectedDate} 
                active={this.state.defaultActive} 
              />
            </div>
          </div>
        </aside>
      );
    }

    return (
      <aside>
        <div>
          <div className={containerClasses}>
            <SidebarNoData 
              selectedDate={selectedDate} 
              active={this.state.defaultActive} 
            />
            {sidebarSetAvailability}
            <SidebarTimeOff
              shiftData={
                this.props.selectedDayData ? this.props.selectedDayData.unavailableShifts : null
              }
              selectedDate={selectedDate}
              unavailableTypes={this.props.unavailableTypes}
              hideFullDay={this.state.setShiftDetailsActive}
              hideCreateButton={hideCreateRequestButton}
            />
            {this.state.setShiftDetailsActive
              && selectedDate
              && this.props.selectedDayData
              && scheduledShifts
              && scheduledShifts.map((shiftData, index) => (
                <SidebarShiftDetails
                  locationId={shiftData.location_id}
                  departmentId={shiftData.department_id}
                  position={shiftData.position}
                  job_site_name={shiftData.job_site_name}
                  job_site_address={shiftData.job_site_address}
                  shiftData={shiftData}
                  selectedDate={that.props.selectedDate}
                  active={that.state.setShiftDetailsActive}
                  toggleOpenSidebar={that.props.toggleOpenSidebar}
                  key={shiftData.id}
                />
              ))}
            <SidebarExchangesAndDrops
              dayShiftData={
                this.props.selectedDayData ? this.props.selectedDayData.scheduledShifts : null
              }
              shiftData={
                this.props.selectedDayData ? this.props.selectedDayData.availableExchanges : null
              }
              selectedExchangeShift={this.props.selectedExchangeShift}
              selectedDate={selectedDate}
              active={this.state.setExchangeAndDropsActive}
              toggleOpenSidebar={this.props.toggleOpenSidebar}
            />
            <SidebarAvailableShifts
              clearSelectedShiftId={this.props.clearSelectedShiftId}
              shiftData={
                this.props.selectedDayData ? this.props.selectedDayData.offeredShifts : null
              }
              selectedDate={selectedDate}
              selectedShift={
                this.props.selectedDayData ? this.props.selectedDayData.selectedShift : null
              }
              active={this.state.setAvailableShiftsActive}
            />
          </div>
          <div className={secondaryClasses} id="secondary-sidebar">
            {!this.props.openCoworkerSidebar 
              ?
                <div>
                  <SidebarExchangeOffer
                    exchangeDaySelectMode={this.props.exchangeDaySelectMode}
                    shiftData={this.props.selectedExchangeShift ? this.props.selectedExchangeShift : null}
                    selectedDate={selectedDate}
                    active={this.state.setExchangeOfferActive}
                    toggleOpenSidebar={this.props.toggleOpenSidebar}
                    selectedExchangeDays={this.props.selectedExchangeDays}
                    removeSelectedDay={this.props.removeSelectedDay}
                  />
                  <SidebarDropOffer
                    shiftData={this.props.selectedExchangeShift ? this.props.selectedExchangeShift : null}
                    exchangeType={this.props.exchangeType}
                    selectedDate={selectedDate}
                    active={this.state.setDropOfferActive}
                    toggleOpenSidebar={this.props.toggleOpenSidebar}
                  />
                  <SidebarExchangeBids
                    shiftData={this.props.selectedExchangeShift ? this.props.selectedExchangeShift : null}
                    exchangeType={this.props.exchangeType}
                    selectedDate={selectedDate}
                    active={this.state.setShiftExchangeBids}
                    toggleOpenSidebar={this.props.toggleOpenSidebar}
                  />
                </div>
              : 
                <SidebarCoworkers selectedDate={selectedDate} />
            }
          </div>
        </div>
      </aside>
    );
  }
}
